import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { useLanguage } from '@app/hooks/useLanguage';
import { BaseSelect, Option } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { languages } from '@app/constants/languages';
import { LanguageType } from '@app/interfaces/interfaces';

export const LanguagePicker: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const currentLanguage = languages.find((lang) => lang.name === language);

  const handleLanguageChange = (value: unknown) => {
    setLanguage(value as LanguageType);
  };

  return (
    <BaseSelect
      value={language}
      onChange={handleLanguageChange}
      style={{ width: 160 }}
    >
      {languages.map((lang) => (
        <Option key={lang.name} value={lang.name}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ReactCountryFlag svg countryCode={lang.countryCode.toUpperCase()} />
            <span>{lang.title}</span>
          </div>
        </Option>
      ))}
    </BaseSelect>
  );
};
